import React, { useState, useRef } from 'react';
import {
    Container,
    Paper,
    Title,
    TextInput,
    Select,
    Button,
    Group,
    Stack,
    Grid,
} from '@mantine/core';
import { IconFileText } from '@tabler/icons-react';
import styles from './DocGenerator.module.css';

const DocGenerator = () => {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [sex, setSex] = useState('female');
    const [day, setDay] = useState('01');
    const [month, setMonth] = useState('01');
    const [age, setAge] = useState('');
    const [variant, setVariant] = useState('1');
    const [uploadedImage, setUploadedImage] = useState(null);
    
    const canvasRef = useRef(null);
    const fileInputRef = useRef(null);

    // Ukrainian translations only
    const t = {
        title: 'Генератор документів',
        name: 'Ім\'я',
        surname: 'Прізвище',
        sex_m: 'Чоловіча',
        sex_f: 'Жіноча',
        months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 
                 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
        age: 'Рік народження',
        variant1: 'Перший варіант (без рамки)',
        variant2: 'Другий варіант (в руці)',
        variant3: 'USA Driver License',
        loadImg: 'Завантажити фото на паспорт',
        generate: 'Генерувати'
    };



    // Handle file upload
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setUploadedImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Random integer generator
    const randomInteger = (min, max) => {
        return Math.round(min - 0.5 + Math.random() * (max - min + 1));
    };

    // Generate document
    const generateDocument = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Fetch random photo
        fetch(`https://royal-bird-baa8.qqlukantr.workers.dev?gender=${sex}`)
            .then(response => response.json())
            .then(data => {
                const genPhoto = data.name;
                
                const passportImage = new Image();
                const passportPhoto = new Image();
                const passportWatermark = new Image();

                // Set onload BEFORE setting src
                passportPhoto.onload = () => {
                    passportImage.onload = () => {
                        ctx.drawImage(passportImage, 0, 0);

                        if (variant === '1') {
                            // Variant 1: Ukrainian passport without frame
                            ctx.drawImage(passportPhoto, 76, 102, 145, 180);
                            
                            if (passportWatermark.src) {
                                passportWatermark.onload = () => {
                                    ctx.drawImage(passportWatermark, 28, 237);
                                };
                            }

                            ctx.font = "16px Arial";
                            ctx.fillStyle = "#000000";
                            ctx.fillText(name, 229, 155);
                            ctx.fillText(surname, 229, 195);
                            ctx.font = "18px Arial";
                            ctx.fillStyle = "#32312D";
                            ctx.fillText(`${day} ${month} ${age}`, 229, 305);
                            ctx.fillStyle = "#44626F";
                            ctx.fillText(sex === 'male' ? 'Male' : 'Female', sex === 'male' ? 520 : 495, 231);

                        } else if (variant === '2') {
                            // Variant 2: Ukrainian passport in hand
                            ctx.drawImage(passportPhoto, 148, 139, 95, 118);
                            
                            if (passportWatermark.src) {
                                passportWatermark.onload = () => {
                                    ctx.drawImage(passportWatermark, 115, 228, 68, 60);
                                };
                            }

                            ctx.font = "11px Arial";
                            ctx.fillStyle = "#000000";
                            ctx.fillText(name, 250, 173);
                            ctx.fillText(surname, 250, 200);
                            ctx.font = "bold 11px Arial";
                            ctx.fillStyle = "#32312D";
                            ctx.fillText(`${day} ${month} ${age}`, 250, 273);
                            ctx.fillStyle = "#44626F";
                            ctx.fillText(sex === 'male' ? 'Male' : 'Female', sex === 'male' ? 439 : 427, 225);

                        } else if (variant === '3') {
                            // Variant 3: USA Driver License
                            ctx.drawImage(passportPhoto, 68, 97, 123, 165);
                            ctx.filter = 'grayscale(100%)';
                            ctx.drawImage(passportPhoto, 412, 222, 64, 80);
                            ctx.filter = 'none';

                            ctx.font = "11px Arial";
                            ctx.fillStyle = "#000000";
                            ctx.fillText(name, 207, 159);
                            ctx.fillText(surname, 207, 173);
                            ctx.font = "bold 11px Arial";
                            ctx.fillStyle = "#32312D";
                            ctx.fillText(`ID${randomInteger(100000000, 999999999)}`, 236, 114);
                            ctx.fillText(`${age}-${month}-${day}`, 234, 128);
                            ctx.fillText(`5'-08"`, 233, 228);
                            ctx.fillText(sex === 'male' ? 'M' : 'F', 235, 217);
                        }
                    };
                    
                    // Set passportImage src AFTER setting onload
                    if (variant === '1') {
                        passportImage.src = 'https://i.imgur.com/Ryn7UmB.png';
                    } else if (variant === '2') {
                        passportImage.src = 'https://i.imgur.com/YAImTjS.png';
                    } else if (variant === '3') {
                        passportImage.src = 'https://i.imgur.com/bb1exB9.png';
                    }
                };

                // Set watermark src and onload
                if (variant === '1') {
                    passportWatermark.src = 'https://i.imgur.com/mzDSpAt.png';
                } else if (variant === '2') {
                    passportWatermark.src = 'https://i.imgur.com/BlotYhy.png';
                }

                // Set passportPhoto src AFTER setting onload
                passportPhoto.src = uploadedImage || `https://this-person-does-not-exist.com/img/${genPhoto}`;
            })
            .catch(error => {
                console.error('Error generating document:', error);
                alert('Помилка при генерації документа. Перевірте консоль для деталей.');
            });
    };

    // Generate days array
    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, '0');
        return { value: day, label: day };
    });

    // Generate months array
    const months = t.months.map((month, i) => ({
        value: String(i + 1).padStart(2, '0'),
        label: month
    }));

    return (
        <Container size="lg" className={styles.container}>
            <Title order={2} mb="xl">
                <Group>
                    <IconFileText size={32} />
                    {t.title}
                </Group>
            </Title>

            <Paper shadow="sm" p="xl" className={styles.formSection}>
                <Grid>
                    <Grid.Col span={{ base: 12, sm: 6 }}>
                        <TextInput
                            label={t.name}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder={t.name}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 6 }}>
                        <TextInput
                            label={t.surname}
                            value={surname}
                            onChange={(e) => setSurname(e.target.value)}
                            placeholder={t.surname}
                        />
                    </Grid.Col>
                </Grid>

                <Stack mt="md" gap="md">
                    <Select
                        label="Стать"
                        value={sex}
                        onChange={setSex}
                        data={[
                            { value: 'female', label: t.sex_f },
                            { value: 'male', label: t.sex_m }
                        ]}
                    />

                    <Group grow className={styles.dateInputs}>
                        <Select
                            label="День"
                            value={day}
                            onChange={setDay}
                            data={days}
                        />
                        <Select
                            label="Місяць"
                            value={month}
                            onChange={setMonth}
                            data={months}
                        />
                        <TextInput
                            label={t.age}
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                            placeholder={t.age}
                        />
                    </Group>

                    <Select
                        label="Варіант"
                        value={variant}
                        onChange={setVariant}
                        data={[
                            { value: '1', label: t.variant1 },
                            { value: '2', label: t.variant2 },
                            { value: '3', label: t.variant3 }
                        ]}
                    />

                    <div className={styles.variantSection}>
                        <label htmlFor="imageLoader" className={styles.uploadLabel}>
                            {t.loadImg}
                        </label>
                        <input
                            ref={fileInputRef}
                            id="imageLoader"
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            className={styles.hiddenInput}
                        />
                    </div>

                    <Button
                        onClick={generateDocument}
                        size="lg"
                        className={styles.generateButton}
                    >
                        {t.generate}
                    </Button>
                </Stack>
            </Paper>

            <div className={styles.canvasContainer}>
                <canvas
                    ref={canvasRef}
                    width={589}
                    height={424}
                    className={styles.canvas}
                />
            </div>
        </Container>
    );
};

export default DocGenerator;
